// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../pplx/frontend/api-clients/core/client.js';
export const visitorClient = createTypedClient();
export const createVisitorClient = (config) => createTypedClient(config);
